import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, getUserVestingState } from "../../angular-wallet-base/store/appState";
import { SubscriptionListenerComponent } from "../../angular-wallet-base/SubscriptionListenerComponent";
import { ModalController } from "@ionic/angular";
import { AppModeService } from "src/app/angular-wallet-base/services/app-mode.service";
import { VaultPromoModalComponent } from "./vault-promo-modal/vault.promo.modal";
import { getERC20TokenList, getKeychain } from "../../angular-wallet-base/store/wallet";
import { environment } from "../../../environments/environment";
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';
import {
  getTokenInfoArray,
  getTokenBalance,
  getTokenFiatValue,
  getCurrentNetworkIcon,
  groupByTokenSymbol,
  openKycModal,
  sortAssetList,
  filterByTokenSymbol
} from '../../angular-wallet-base/utils';
import { SmallToCryptoPipe } from "../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.pipe";
import BigNumber from "bignumber.js";
import { ERC20tokenData, TokenInfo, UnconfirmedTransaction } from "../../global";
import { getTokenKeyring, getUnconfirmedTxs } from "../../angular-wallet-base/store/wallet";
import { isNumeric } from "rxjs/internal-compatibility";
import { ASSET_ALLOCATION_FEE, GRAPH_DATA_HOME, SMART_CONTRACT_CHAINS } from "../../angular-wallet-base/constants";
import { createKeyringId } from "../../angular-wallet-base/keyringUtils";
import { NetworkService } from "../../angular-wallet-base/services/network.service";
import {
  ChartComponent
} from "ng-apexcharts";
import { getBaseCurrency } from "../../angular-wallet-base/store/userPreferences";
import { SelectAssetModal, SelectTokenInfo } from '../select-asset-modal/select-asset-modal.component';
import { getCoinNameBySymbol } from "src/app/angular-wallet-base/utils";
import { MembersPortalService } from "src/app/angular-wallet-base/services/members-portal.service";
import { getSideMenuStatus } from "src/app/angular-wallet-base/store/appSettings";
import { take } from "rxjs/operators";
import { TokenDefinitionService } from "../../angular-wallet-base/services/token-definition.service";
import { Router } from "@angular/router";
import { timer } from 'rxjs';
import { ComplianceService } from "../../angular-wallet-base/services/compliance.service";
import { inspect } from "util";
import { Logger } from "src/app/angular-wallet-base/services/logger.service";
import { StorageService } from "src/app/angular-wallet-base/services/storage.service";
import { RoutingService } from "../../angular-wallet-base/services/routing.service";
import { MoralisService } from "src/app/angular-wallet-base/services/moralis.service";
import { ImportAssetModalComponent } from "./add-new-token-modal/add-new-token.modal";
import { ImportOrHideAssetModalComponent } from "./import-or-hide-token-modal/import-or-hide-token.modal";
import { supportedAssetList } from "src/app/angular-wallet-base/lib/supported-assets/supported-assets";
import { GraphService } from "src/app/angular-wallet-base/services/graph.service";
import { OneInchService } from "src/app/angular-wallet-base/services/one-inch.service";
import { VestingLtcStateInitRequestAction } from "src/app/angular-wallet-base/actions/vestingLTC.actions";





@Component({
  selector: "vault-intro",
  templateUrl: "vault.component.html",
  styleUrls: ["vault.component.scss"],
})
export class VaultPage extends SubscriptionListenerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("chart", { static: false }) chart: ChartComponent;

  private isLodeEnabled = environment.features.linkLode;
  public totalBalance;
  public groupedTokens;
  public tokens: SelectTokenInfo[] = [];
  public tokenInfo: TokenInfo;
  public filteredTokens: any = [];
  public currentBaseCurrency: any;
  public aggregatedTokenEnabled = environment.features.aggregateTokens;
  public unconfirmedTxs: UnconfirmedTransaction[] = [];
  public baseToken = null;
  public guid;
  public transactionList = [];
  private sysBalance;
  public currentBalance;
  private sysTxRate;
  public currentTxNumber;
  public baseChainName;
  public countdown: string;
  public interval: number;
  private completed: boolean;
  public chartOptions;
  public vaultChartOptions;
  public chartYAxis = [];
  public activeYAxis = 5;
  public showChart = false;
  public waveSvg = "vault";
  public activeOptionButton = "ALL";
  public selectedDate = "";
  public isDesktopMode;
  public updateOptionsData;
  public graphDataSet;
  public tapToReveal: boolean;
  public tapText: string = 'add_asset_vault_page.tap_to_reveal';

  currentDate: any;
  targetDate: any;
  cDateMillisecs: any;
  tDateMillisecs: any;
  difference: any;
  seconds: any;
  minutes: any;
  hours: any;
  days: any;
  year: number = 2022;
  month: number = 11;
  months = ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  day: number = 31;
  offer: boolean = false;
  offerInterval;
  amountInterval;
  newMemberOfferData: any;
  newMember: boolean;
  timeData: string;
  applyPromo: boolean;
  tokensForImportERC20token: Array<any> = [];
  vestLtc = 0;
  hiddenERC20tokens: Array<ERC20tokenData>;
  vestingUserInfo = {
    ltcBalance: null,
    hasDeposited: false,
    isStaking: false,
    vestingInfo: {
      depositTimestamp: new Date(0),
      depositBalance: 200,
      amountClaimed: 0,
      claimableBalance: 0,
    },
    stakingInfo: {
      amountStaked: 0,
      interestEarned: 0,
      interestClaimed: 0,
    },
  };
  vestingMessage: string = null;
  vestingIsLoading: boolean = true;
  vestingError: boolean = false;
  constructor(
    protected store: Store<AppState>,
    public modalController: ModalController,
    private membersPortalService: MembersPortalService,
    private smallToCrypto: SmallToCryptoPipe,
    private router: Router,
    private routingService: RoutingService,
    private networkService: NetworkService,
    public appMode: AppModeService,
    private authGuardService: AuthGuardService,
    private complianceService: ComplianceService,
    private storage: StorageService,
    private moralisService: MoralisService,
    private graphService: GraphService,
    private oneInchService: OneInchService,
  ) {
    super(store);
    this.chartYAxis = this.graphService.chartYAxis.getValue();
    this.updateOptionsData = this.graphService.updateOptionsData.getValue();
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
    const tabInstance = this;
    // fetching graph data after each transactions
    this.graphService.chartCount.subscribe((count) => {
      this.fetchStorageData();
    });
  }


  async fetchStorageData() {
    //Fetching graph data from localstorage and initializing to chart
    this.graphDataSet = await this.storage.get(GRAPH_DATA_HOME);
    if (this.graphDataSet && this.graphDataSet.length > 0) {
      this.vaultChartOptions.series[0].data = this.graphDataSet;
      this.initChart();
    } else {
      this.showChart = false;
    }
  }

  bigInt(weiValue: number) {
    return parseFloat((Number(weiValue) / (10 ** 17)).toFixed(6))
  }

  async getWalletAddress() {
    const coinKeyring = await this.store
      .select(getTokenKeyring, {
        keyringId: "AVAX",
      })
      .first()
      .toPromise();
    return coinKeyring.address;
  }

  async ngOnInit() {
    this.vaultChartOptions = await this.graphService.getVaultPagechartOptions(this.isDesktopMode, this);
    this.getMemberData();
    this.initChart();

    await this.oneInchService.initiateConnection();
    this.store.dispatch(new VestingLtcStateInitRequestAction(await this.getWalletAddress()));
    this.store.select(getUserVestingState).subscribe(user => {
      this.vestingUserInfo = user.userVestingLTC;
      this.vestingIsLoading = user.loading;
      this.vestingError = user.error;
      this.vestingMessage = user.message;
      this.vestLtc = this.bigInt(user.userVestingLTC.vestingInfo.depositBalance) - this.bigInt(user.userVestingLTC.vestingInfo.amountClaimed) - this.bigInt(user.userVestingLTC.stakingInfo.amountStaked);
    })

    this.subscriptions.add(
      this.store.select(getKeychain).subscribe(async (keychain) => {
        if (!keychain) {
          // Prevent error on wallet reset.
          return;
        }
        //filter all PT asets out of the list
        const listOfSupportedAssets = Object.values(supportedAssetList);
        Logger.info('listOfSupportedAssets', listOfSupportedAssets);
        this.currentBaseCurrency = await this.store.select(getBaseCurrency).pipe(take(1)).toPromise();
        keychain = Object.keys(keychain).reduce((obj, key) => {
          return Object.assign(obj, { [key]: keychain[key] })}, {});
        let tokens = await Promise.all(
          getTokenInfoArray(keychain)
            .sort((a, b) => a?.symbol?.charCodeAt(0) - b?.symbol?.charCodeAt(0))
            .map(async (token) => {
              const tokenCopy: any = { ...token };
              tokenCopy.preciseBalance = this.smallToCrypto.transform(tokenCopy.balance, {
                type: tokenCopy.baseChainSymbol,
                precision: tokenCopy.precision
              });
              tokenCopy.balance = tokenCopy.balance ? tokenCopy.balance.toString() : '0';

              tokenCopy.iconChain = await getCurrentNetworkIcon(tokenCopy.symbol, tokenCopy.baseChainSymbol);
              const found = listOfSupportedAssets.find(asset => asset.assetGuid?.toLowerCase() === token.assetGuid?.toLowerCase())

              tokenCopy.canRemovable = !!found;
              return tokenCopy;
            })
        );

        // for adding ERC20 token operation
        this.tokensForImportERC20token = [];
        const currentNetwork = await this.networkService.getActiveAvaxNetwork();
        const contractChains = SMART_CONTRACT_CHAINS.filter(chain =>
          chain.isSmartContractChain && chain.network === currentNetwork.network);
        contractChains.forEach(chain => {
          const foundedToken = tokens.find(token => (token.symbol === chain.chain && token.baseChainSymbol === chain.chain));
          if (foundedToken) {
            this.tokensForImportERC20token.push(foundedToken);
          }
        });
        tokens = tokens.filter(token => token.baseChainSymbol != 'HL');
        this.getBalance(tokens);

        // this.isLodeLinked = await this.membersPortalService.isJwtValid();

        // We have some new requirements
        const filteredTokens = filterByTokenSymbol(tokens, "symbol");

        // need to add USDC.e for aggregating balance
        const tokenForAggregation = tokens.map(token => {
          const tokenCopy: any = { ...token };
          if (tokenCopy.symbol === 'USDC.e') {
            tokenCopy.symbol = 'USDC';
          } else if (tokenCopy.symbol === 'LTC') {
            tokenCopy.symbol = 'LODE';
          } 
          return tokenCopy;
        });
        const groupedTokens = groupByTokenSymbol(tokenForAggregation);
        for (let i = 0; i < filteredTokens.length; i++) {
          const filteredToken: any = { ...filteredTokens[i] };
          const aggregateObj = this.calculateAggregatedBalance(groupedTokens, filteredToken.symbol, filteredToken.fiatValue);
          filteredToken.aggregateTotalBalance = aggregateObj.aggregatedBalance;
          filteredToken.aggregateTotalFiat = aggregateObj.aggregatedFiatBalance;
              
          const tokensList = tokens.filter((filterToken) => {
            if (filteredToken.symbol === 'USDC') {
              return ['USDC', 'USDC.e'].includes(filterToken.symbol)
            } else if (filteredToken.symbol === 'LODE') {
              return ['LODE', 'LTC', 'VOT3'].includes(filterToken.symbol)
            } else {
              return filteredToken.symbol === filterToken.symbol;
            }
          });
          filteredToken.tokens = tokensList;
  
          filteredTokens[i] = filteredToken;
        }
        this.groupedTokens = groupedTokens;
        this.tokens = environment.features.aggregateTokens ? filteredTokens : tokens;
        this.filteredTokens = await sortAssetList(this.tokens);

      })
    );
    this.subscriptions.add(
      this.store.select(getERC20TokenList).subscribe(tokens => this.hiddenERC20tokens = tokens)
    );

  }

  async ionViewWillEnter() {
    await this.fetchStorageData();
  }
  private async getBalance(tokens: any[]) {
    // Mobile
    // calculate total fiat balance using only tokens that have an available fiatValue
    let newBalances = 0.00;
    for (const token of tokens) {

      try {
        if (token.fiatValue) {
          let num = getTokenFiatValue(token.fiatValue, getTokenBalance(token));
          num = this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision });
          newBalances += new BigNumber(num).toNumber();
        }
      } catch (e) {
        Logger.error('VaultComponent- getBalance - token', token, inspect(e));
      }
    }
    this.totalBalance = newBalances;
  }


  public getBalanceOfERC20token(num, token) {
    return this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision })
  }

  async getTransactionHistory(baseToken, guid) {
    this.baseToken = baseToken;
    this.guid = guid;

    const keyringId = createKeyringId(this.baseToken, this.guid);

    this.subscriptions.add(
      this.store.select(getTokenKeyring, { keyringId }).subscribe(async (keyring) => {
        // Logger.info('keyring update!');
        this.tokenInfo = { ...keyring, ...TokenDefinitionService.getTokenDefinition(createKeyringId(this.baseToken, keyring?.guid)) };
        this.transactionList = keyring.transactions ? [...keyring.transactions] : [];
        this.currentBalance = getTokenBalance(keyring);
      })
    );

    this.subscriptions.add(
      this.store.select(getUnconfirmedTxs).subscribe((txs) => {
        this.unconfirmedTxs = txs.filter((tx) => {
          return tx.tokenInfo.keyringId === this.tokenInfo.keyringId;
        });
        this.unconfirmedTxs.reverse();
      })
    );

    if (keyringId === 'SYS') {
      const sysKeyring = await this.store.select(getTokenKeyring, { keyringId: "SYS" }).pipe(take(1)).toPromise();
      this.sysTxRate = sysKeyring.feePerAssetTx + ASSET_ALLOCATION_FEE;
      this.sysBalance = sysKeyring.balance;
      this.sysBalance = Number(this.sysBalance);
  
      const sysBalanceSmallCrypto = this.smallToCrypto.transform(this.sysBalance, { type: this.tokenInfo.baseChainSymbol });
      this.currentTxNumber = Math.floor(sysBalanceSmallCrypto / this.sysTxRate);
    }
    this.baseChainName = getCoinNameBySymbol(this.tokenInfo.baseChainSymbol);
  }

  private getTime(): string {
    if (this.interval < 0) {
      this.interval = Math.abs(this.interval);
      this.completed = true;
    }
    const hours = Math.floor(this.interval / 3600);
    const minutes = Math.floor((this.interval - (hours * 3600)) / 60);
    const seconds = (this.interval - (hours * 3600) - (minutes * 60));
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private manipulateInterval() {
    this.interval--;
  }

  countdownCompleted() {
    this.completed = true;
    this.getMemberData();
  }

  getVestingLtcAmount() {
    const LTC =  this.tokens.find(token => token.symbol === "LTC");
    return this.vestLtc * LTC.fiatValue;
  }

  async getMemberData() {
    this.countdown = this.getTime();
    timer(1000, 1000).subscribe(val => {
      this.manipulateInterval();
      this.countdown = this.getTime();
      if (this.interval === 0) {
        this.countdownCompleted();
      }
    });
    var newMemberPromo = await this.membersPortalService.getNewMemberPromoData();
    Logger.info(newMemberPromo.data.length)
    if (newMemberPromo.data.length == 0) {
      this.newMember = false;
    } else {
      this.newMemberOfferData = newMemberPromo.data[0];
      this.newMember = true;
      var hour = this.newMemberOfferData.timeRemaining.hours * 60 * 60;
      var min = this.newMemberOfferData.timeRemaining.minutes * 60;
      this.interval = hour + min + this.newMemberOfferData.timeRemaining.seconds;
    }
  }

  calculateAggregatedBalance(groupedTokens, symbol, fiatVal) {
    const aggregatedTokens = groupedTokens[symbol];
    const aggregateTotal = {
      aggregatedBalance: 0, aggregatedFiatBalance: 0
    }
    if (aggregatedTokens instanceof Array) {
      // let aggregatedBalance = 0;
      aggregatedTokens.forEach((token) => {
        if (token.balance) {
          const numBalance = this.smallToCrypto.transform(token.balance, { type: token.baseChainSymbol, precision: token.precision });
          token.preciseBalance = numBalance;
          aggregateTotal.aggregatedBalance += new BigNumber(numBalance).toNumber();
          // let fiatBalance =  
        }
        if (token.fiatValue) {
          let num = Number(token.fiatValue || 0) * Number(token.balance || 0);
          num = this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision });
          aggregateTotal.aggregatedFiatBalance += new BigNumber(num).toNumber();
        }
        if (!token.fiatValue) {
          token.fiatValue = fiatVal;
        }
      });
    }
    return aggregateTotal;
  }

  getTokenFiatValue(fiatRate, balance) {
    fiatRate = fiatRate ? fiatRate : 0;
    return getTokenFiatValue(fiatRate, balance);
  }

  getTokenBalanceOfToken(token: any) {
    return this.aggregatedTokenEnabled
      ? token.aggregateTotalBalance
      : this.smallToCrypto.transform(token.balance, { type: token.baseChainSymbol, precision: token.precision });
  }

  getAssetBalance(token: any) {
    var result = this.smallToCrypto.transform(token.balance, { type: token.baseChainSymbol, precision: token.precision });
    return result;
  }

  ngOnDestroy() {
    clearTimeout(this.offerInterval);
    clearTimeout(this.amountInterval);
  }

  initChart() {
    this.chartOptions = this.vaultChartOptions;
    this.showChart = (this.graphDataSet && this.graphDataSet.length > 0) ? true : false;
    setTimeout(() => {
      this.updateOptions("ALL");
    }, 1000);
  }

  public updateOptions(option: any): void {
    this.selectedDate = "";
    this.activeOptionButton = option;
    const updatedOptions = this.updateOptionsData[option];
    const updatedData = [];
    for (const data of this.graphDataSet) {
      if (data[0] <= updatedOptions.xaxis.max && data[0] >= updatedOptions.xaxis.min) {
        updatedData.push(data);
      }
    }
    if (updatedData.length > 0) {
      updatedOptions.xaxis.max = updatedData[0][0];
      updatedOptions.xaxis.min = updatedData[updatedData.length - 1][0];
    }
    this.chart.updateOptions(updatedOptions, false, true, true);
  }

  resetChart() {
    this.activeOptionButton = "ALL";
    this.selectedDate = "";
    this.showChart = false;
    this.initChart();
  }

  ngAfterViewInit() {
  }

  async openVaultPromoModal() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();

    let cssClass = "vault-promo-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";

    const modal = await this.modalController.create({
      component: VaultPromoModalComponent,
      cssClass,
      componentProps: {
        newMember: this.newMemberOfferData,
      },
    });
    await modal.present();
    await modal.onDidDismiss().then(async resp => {
      if (resp.data.action == "buy-assets") {
        this.presentModal('buy')
        this.applyPromo = true;
      }
    });
  }

  async isExpandChange(i, item: any) {
    if (item.tokens.length > 0 && !["BTC", "ETH", "SYS", "SOL", "AVAX"].includes(item.symbol)) {
      this.filteredTokens[i]["isExpanded"] = !this.filteredTokens[i]["isExpanded"];
    } else {
      await this.getTransactionHistory(item.baseChainSymbol, item.guid);
      const token = item;
      const unconfirmedTxs = this.unconfirmedTxs;
      this.authGuardService.setTokenData({ tokenInfo: token, unconfirmedTxs });
      this.router.navigate(["/vault-intro/token-page"]);
    }
  }

  async isExpandChangeChild(item: TokenInfo) {
    await this.getTransactionHistory(item.baseChainSymbol, item.guid);
    const token = item;
    const unconfirmedTxs = this.unconfirmedTxs;
    this.authGuardService.setTokenData({ tokenInfo: token, unconfirmedTxs });
    this.router.navigate(["/vault-intro/token-page"]);
  }

  formatNumber(num = "") {
    if (isNumeric(num)) {
      const value = Number(num); // new BigNumber(num).toNumber();
      if (Math.abs(value) > 999) {
        const absValue = Math.sign(value) * (Math.abs(value) / 1000);
        return Math.floor(absValue * 100) / 100 + "k";
      }
      return Math.sign(value) * Math.abs(value);
    }
    return 0;
  }

  parseBaseChainSymbol(chain) {
    switch (chain) {
      case "SYS":
        return "Syscoin";
      case "SOL":
        return "Solana";
      case "HL":
        return "HyperLedger";
      case "AVAX":
        return "Avalanche";
      case "ETH":
        return "Ethereum";
      case "SYSNEVM":
        return "SYS-ROLLUX";
      default:
        return "Unknown";
    }
  }

  async presentModal(mode: string) {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    this.modalController.dismiss();

    if (mode == "buy") {
      var kycData = await this.complianceService.getKycCip();
      if (!kycData["passingLevel"]) {
        await openKycModal(sideMenuHidden, this.isDesktopMode, this.modalController);
        return;
      }
    }

    let cssClass = "";
    cssClass += this.isDesktopMode ? "select-asset-modal-desktop" : "select-asset-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";
    const modal = await this.modalController.create({
      component: SelectAssetModal,
      componentProps: {
        actionType: mode,
        newMember: this.applyPromo == true ? true : false,
        promocode: this.applyPromo == true ? this.newMemberOfferData.attributes.code : null
      },
      cssClass,
      id: 'select-asset-model',
      initialBreakpoint: this.isDesktopMode ? undefined : 0.9,
      breakpoints: this.isDesktopMode ? undefined : [0, 0.6, 0.9, 1],
    });
    await modal.present();
    await modal.onDidDismiss().then();
  }

  async goBack() {
    await this.routingService.goHome();
  }

  revealUserAsset() {
    this.tapToReveal = !this.tapToReveal;
    this.tapText = this.tapToReveal ? 'add_asset_vault_page.tap_to_hide' : 'add_asset_vault_page.tap_to_reveal';
  }

  async openImportTokenModal() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'add-new-token-modal-desktop' : 'add-new-token-modal';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
    const modal = await this.modalController.create({
      component: ImportAssetModalComponent,
      cssClass,
      componentProps: {
        tokensForImportERC20token: this.tokensForImportERC20token
      },
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.7,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.7, 1],
      id: 'add-new-token-modal',
      backdropDismiss: false
    });
    await modal.present();
  }

  async importOrHideAsset(isImport: boolean, asset: any) {
    Logger.info('importOrHideAsset', asset);
    if (!asset.canRemovable && !isImport) { return; }
    const assetForImport = {...asset};
    this.moralisService.setERC20tokenData(assetForImport);
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'purchase-gas-modal-desktop' : 'purchase-gas-modal';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
    const modal = await this.modalController.create({
      component: ImportOrHideAssetModalComponent,
      cssClass,
      componentProps: {
        isImport,
        importFromVault: true
      },
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.5,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.5, 0.6, 1],
      backdropDismiss: false
    });
    await modal.present();
    await modal.onDidDismiss().then();
  }
}
